export const EDITOR_TAB_PANEL_SCROLL_REGION = "tab-panel" as const;
